import { useEffect, useState } from "react"
import { get } from "helpers/api_helper"
import { penaltyUrl } from "./penaltyView"

export default function usePenaltyPreview({ competitionId, startDate, banned, ready = true }) {
  const [state, setState] = useState({}), [attempt, setAttempt] = useState(0)
  const key = JSON.stringify([competitionId, startDate, banned, ready, attempt])
  useEffect(() => {
    let current = true
    setState({ key, loading: true })
    if (ready && startDate && banned !== "") get(penaltyUrl(competitionId) + "/preview", { params: { startDate, banned } })
      .then(result => { if (current) setState({ key, data: result.data }) })
      .catch(() => { if (current) setState({ key, error: true }) })
    return () => { current = false }
  }, [competitionId, startDate, banned, ready, key])
  return { ...state, valid: state.key === key && state.data?.competitionId === competitionId, retry: () => setAttempt(value => value + 1) }
}
